/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { OAuth2Error } from "oauth4webapi";
import { isOAuth2Error } from "oauth4webapi";

type IsErrorInputs = Parameters<typeof isOAuth2Error>[0];
export function throwIfError<T extends IsErrorInputs>(
  result: T | OAuth2Error,
): Exclude<T, OAuth2Error> {
  if (isOAuth2Error(result)) {
    throw new Error(`Failed to get token: ${result.error}`);
  }
  return result as any;
}
